function videoSchema() {
  return {
    '@context': 'http://schema.org',
    '@type': 'VideoObject',
    name: 'Unacademy | The Greatest Lesson',
    description:
      'The sound of success is strung with notes.  Notes of despair.  Of grit and rigour.  Of the pit of fire.  Fueled by dreams and passion.  Of the journey that shakes confidence.  Of the journey that shapes character.  The sound of success is loud.  But the silence of hard work and perseverance speaks louder.  So, rekindle the dreams,  Rebuild the path. For those who crack it, seldom give up.  They keep going amidst all odds,  For passion is undefeatable.  #TheGreatestLesson feat. Sachin Tendulkar  #SachinUnacademyFilm',
    thumbnailUrl: 'https://i.ytimg.com/vi/7nYLfqkI8ZA/default.jpg',
    uploadDate: '2021-03-02T05:30:00Z',
    duration: 'PT2M15S',
    embedUrl: 'https://www.youtube.com/embed/7nYLfqkI8ZA',
    interactionCount: '102247532'
  };
}

export default videoSchema;
